import { AssessmentInfo, AssessmentResponse,  FileResponse, Patient, TeethType, User } from '@opp/shared';  
import { createContext } from 'react';

export interface AssessmentContextData {
  patient?: Patient;
  setPatient: (patient: Patient) => void;
  responsible?: User;
  setResponsible: (responsible: User) => void;
  info?: AssessmentInfo;
  setInfo: (info: AssessmentInfo) => void;
  photos?: FileResponse[];
  setPhotos: (photos: FileResponse[] | ((prev?: FileResponse[]) => FileResponse[] | undefined)) => void;
  presentationEnabled: boolean;
  setPresentationEnabled: (enabled: boolean) => void;
  teeth?: TeethType[];
  setTeeth: (teeth: TeethType[]) => void;
  previewImage?: {
    image: string;
    title: string;
    photoKey: string;
  };
  setPreviewImage: (previewImage?: { image: string; title: string, photoKey: string }) => void;
  editImage?: {
    image: string;
    title: string;
    photoKey: string;
  };
  setEditImage: (editImage?: { image: string; title: string, photoKey: string }) => void;
  createAssessment: (info: AssessmentInfo) => Promise<AssessmentResponse>;
  loadAssessment: (id: string) => Promise<void>;
  updateAssessment: () => Promise<void>;
  uploadImage: (originalFile: File, key: string, editedFile?: File) => Promise<void>;
  resetFiles: (key: string) => Promise<void>;
  reset: () => void;
  /** Em edição: true quando loadAssessment terminou. Em novo: true após a página ter carregado. */
  isAssessmentReady: boolean;
  /** Quando false, não dispara salvamento automático ao alterar o contexto (ex.: modo leitura). */
  allowAutoPersist: boolean;
  setAllowAutoPersist: (value: boolean) => void;
}

export const AssessmentContext = createContext<AssessmentContextData>({} as AssessmentContextData);
